let initReport = (nga) => {
    let entity = nga.entity('notification_report').label('Email report');
    let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}});
    let firstStreamField = nga.field('first_stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search, discriminator: 1}}});
    let secondStreamField = nga.field('second_stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search, discriminator: 1}}});
    let periodField =  nga.field('period', 'choice').choices(
        [
          {value: 'daily', label: 'Daily'},
          {value: 'weekly', label: 'Weekly'},
          {value: 'weekdays', label: 'Weekdays'}]).validation({required: true});
    let dayOfWeekField = nga.field('day_of_week', 'number');
    let userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person'))
        .targetField(nga.field('full_name')).remoteComplete(true, {searchQuery: (search) => {return {full_name__icontains: search}}});
    let usersField = nga.field('users', 'referenced_list').targetEntity(nga.entity('notification_report_user')).targetReferenceField('report_id')
        .targetFields([nga.field('id'), userField])
        .listActions(['edit'])
    let emailsField = nga.field('emails', 'referenced_list').targetEntity(nga.entity('notification_report_email')).targetReferenceField('report_id')
        .targetFields([nga.field('id'), nga.field('email')])
        .listActions(['edit'])
    entity.listView().title('Email report list').fields([
      nga.field('id').isDetailLink(true),
      firstStreamField,
      secondStreamField,
      subscriptionField,
      periodField,
      nga.field('last_sent_at', 'unixtime'),
      nga.field('disabled_at', 'unixtime'),
     ]);
    entity.creationView().fields([
      firstStreamField,
      secondStreamField,
      subscriptionField,
      periodField,
      dayOfWeekField,
      usersField,
      emailsField
    ]);
    entity.editionView().fields([
      firstStreamField,
      secondStreamField,
      subscriptionField,
      periodField,
      dayOfWeekField,
      usersField,
      emailsField,
      nga.field('disabled_at', 'bool_timestamp')
    ]);
    return entity;
}

let initReportUser = (nga) => {
    let entity = nga.entity('notification_report_user').label('Email report user');
    let reportField = nga.field('report_id', 'reference').label('Report').targetEntity(nga.entity('notification_report'))
        .targetField(nga.field('id')).remoteComplete(true, {searchQuery: (search) => {return {id: search}}});
    let userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person'))
        .targetField(nga.field('full_name')).remoteComplete(true, {searchQuery: (search) => {return {full_name__icontains: search}}});
    entity.listView().title('Email report list').fields([
      nga.field('id').isDetailLink(true),
      userField,
      reportField
     ]).filters([
       reportField,
       userField
     ]);
    entity.creationView().fields([
      userField,
      reportField
    ]);
    entity.editionView().fields([
      userField,
      reportField
    ])

    return entity;
}

let initReportEmail = (nga) => {
    let entity = nga.entity('notification_report_email').label('Email report user');
    let reportField = nga.field('report_id', 'reference').label('Report').targetEntity(nga.entity('notification_report'))
        .targetField(nga.field('id')).remoteComplete(true, {searchQuery: (search) => {return {id: search}}});
    let emailField = nga.field('email', 'string').label('Email');
    entity.listView().title('Email report list').fields([
      nga.field('id').isDetailLink(true),
      emailField,
      reportField
     ]).filters([
       reportField,
       emailField
     ]);
    entity.creationView().fields([
      emailField,
      reportField
    ]);
    entity.editionView().fields([
      emailField,
      reportField
    ])

    return entity;
}


export {initReport, initReportUser, initReportEmail};


// WEBPACK FOOTER //
// ./client/app/entities/notification.js